import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { DeliveryAreaService } from '../delivery-area.service';
import { DeliveryOverviewService } from './delivery-overview.service';
import { DeliveryOverviewTab1Part } from './tabs/tab-1/delivery-overview-tab-1.part';
import { DeliveryOverviewTab2Part } from './tabs/tab-2/delivery-overview-tab-2.part';
import { DeliveryOverviewViewsPart } from './views/overview-views.part';

@Component({
	selector: 'delivery-overview-page',
	standalone: true,
	imports: [
		DeliveryOverviewTab1Part, DeliveryOverviewTab2Part, DeliveryOverviewViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-overview.page.html',
})
export class DeliveryOverviewPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public deliveryService = inject(DeliveryAreaService);


	constructor(
		public pageService: DeliveryOverviewService,
	) {
	}

	async ngOnInit() {
		await this.deliveryService.loadDeliveryData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}